<div class="intro--banner">
    <h1 class="ml-lg-5 ml-md-5 ml-1">We're relevant because <br/> we optimize the up-to-date,<br>to have you styled digitally </h1>
    <div class="circle images">

        <img src="assets/big-circle.png" class="bigimg" alt="circle">
        <div class="arrow-img">
            <img src="assets/banner-arrow.png" alt="arrow">

        </div>
        <div class="small-circle">
            <img src="assets/small-circle.png" alt="circle">

        </div>
    </div>
    <div class="arrow-bottom">
        <img src="assets/arrow-bottom.png" class="arrow_bottom" alt="arrow" (click)="navigateNext()">
    </div>

</div>